import {AssistantRunStatus} from "@/helper/chat/assistantRun/assistantRunStatus";

export enum ChatStatus {
    READY,
    EXPECTING_NEXT_RESPONSE,
    // Optional:prepand
        PREPENDING_ASSISTANT_MESSAGE,
    // Optional:chooser
        CHOOSER_PENDING,
        // Optional: Infrastructure (Thread & assistant)
        // CHOOSER_SETUP = 0,
        // requesting
        // CHOOSER_REQUESTING = 1,
        // response streaming
        // CHOOSER_RESPONDING = 2,
        // complete
        // CHOOSER_COMPLETE = 3,
    // Expert
        // Optional: Infrastructure (Thread & assistant) and also run before request started
        EXPERT_SETUP,
    // requesting
    EXPERT_REQUESTING,
    // response streaming
    EXPERT_RESPONDING,
        // toolcall
        // EXPERT_TOOLCALL,
        // text streaming
        // EXPERT_TEXT_STREAMING,
    // complete
    EXPERT_COMPLETE,
    // any failure lands here
    FAILED,
}

export namespace ChatStatus {
    export const stringify = (status: ChatStatus): string => ChatStatus[status] + " [" + status + "]"

    export const isResting = (status: ChatStatus): boolean => [ChatStatus.READY].includes(status) || ChatStatus.isDone(status)
    export const isPending = (status: ChatStatus): boolean => !ChatStatus.isResting(status)
    export const isChoosing = (status: ChatStatus): boolean => [ChatStatus.CHOOSER_PENDING].includes(status)
    export const isExperting = (status: ChatStatus): boolean => [ChatStatus.EXPERT_REQUESTING, ChatStatus.EXPERT_RESPONDING].includes(status)
    export const isDone = (status: ChatStatus): boolean => [ChatStatus.EXPERT_COMPLETE, ChatStatus.FAILED].includes(status)

    export const fromAssistantRunState = (state: AssistantRunStatus) : ChatStatus => {
        switch (state) {
            case AssistantRunStatus.INIT: return ChatStatus.EXPERT_SETUP
            case AssistantRunStatus.REQUESTED: return ChatStatus.EXPERT_REQUESTING
            case AssistantRunStatus.RUNNING: return ChatStatus.EXPERT_RESPONDING
            case AssistantRunStatus.PENDING_TOOL_CALL: return ChatStatus.EXPERT_RESPONDING // leave in responding
            case AssistantRunStatus.COMPLETED: return ChatStatus.EXPERT_COMPLETE
            case AssistantRunStatus.FAILED: return ChatStatus.FAILED
            case AssistantRunStatus.CANCELLED: return ChatStatus.FAILED
        }
    }
    export function transitionTo(nextState: ChatStatus, previousState: ChatStatus, force: boolean = false) : ChatStatus {
        if (
            nextState >= previousState || // always up
            (nextState === ChatStatus.READY && ChatStatus.isDone(previousState)) || // always allow reset to init from done
            (nextState === ChatStatus.READY && force) // always allow reset to init by force
        ) {
            return nextState;
        }

        console.error("drop chatStatus" + (force ? 'FORCED' : '') + " transition from " + ChatStatus.stringify(previousState) + " to " + ChatStatus.stringify(nextState))
        return previousState
    }
}
